export default __webpack_public_path__ + "static/banner-img-819a75724264e65fd17f6960a54c41e3.png";